/** Service appointment ("cita de servicio") for After-sales business units. */

export const APPOINTMENT_TYPES = ['mantencion', 'dyp', 'repuestos', 'cambio-aceite', 'diagnostico'] as const;
export type AppointmentType = (typeof APPOINTMENT_TYPES)[number];

export const APPOINTMENT_STATUSES = ['pending', 'done', 'cancelled'] as const;
export type AppointmentStatus = (typeof APPOINTMENT_STATUSES)[number];

/** User-facing Spanish labels — code values stay in their canonical form. */
export const APPOINTMENT_TYPE_LABELS: Record<AppointmentType, string> = {
  mantencion: 'Mantención',
  dyp: 'DYP',
  repuestos: 'Repuestos',
  'cambio-aceite': 'Cambio de aceite',
  diagnostico: 'Diagnóstico',
};

export const APPOINTMENT_STATUS_LABELS: Record<AppointmentStatus, string> = {
  pending: 'Pendiente',
  done: 'Realizada',
  cancelled: 'Cancelada',
};

export interface AppointmentClient {
  id: number;
  firstName: string | null;
  lastName: string | null;
  rut: string | null;
  phone: string | null;
  email: string | null;
  source: string | null;
}

export interface AppointmentCar {
  id: number;
  brand: string | null;
  model: string | null;
  licensePlate: string | null;
  km: number | null;
  year: number | null;
}

export interface Appointment {
  id: number;
  businessUnitId: number;
  clientId: number | null;
  carId: number | null;
  advisorName: string | null;
  branchOffice: string;
  date: string; // ISO timestamp
  durationMinutes: number;
  type: AppointmentType;
  status: AppointmentStatus;
  maintenanceInterval: string | null;
  notes: string | null;
  client?: AppointmentClient | null;
  car?: AppointmentCar | null;
  createdAt: string;
  updatedAt: string;
}

export interface AppointmentDraft {
  businessUnitId: number;
  clientId?: number | null;
  carId?: number | null;
  advisorName?: string | null;
  branchOffice: string;
  date: string; // ISO timestamp
  durationMinutes?: number;
  type: AppointmentType;
  status?: AppointmentStatus;
  maintenanceInterval?: string | null;
  notes?: string | null;
}

/** Display name for an appointment's client, falling back when unlinked. */
export const appointmentClientName = (appointment: Appointment): string => {
  const name = [appointment.client?.firstName, appointment.client?.lastName].filter(Boolean).join(' ').trim();
  return name || 'Sin cliente';
};
